import * as React from 'react';
import { InputMobile, InputDesktop } from '../pages/Authentication/styles';
import Input from '../components/Input';

interface Props {
  widthMobile?: string;
  widthDesktop?: string;
  inputType?: string;
  onClick?: () => void;
  placeholder?: string;
  type?: string;
  value?: string;
  isLabel?: boolean;
  labelText?: string;
  isColor?: boolean;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
}
const MediaInputs = (props: Props) => {
  return (
    <>
      <InputMobile>
        <Input
          inputType={props.inputType}
          width={props.widthMobile}
          placeholder={props.placeholder}
          type='text'
          value={props.value}
          onChange={props.onChange}
          isColor={props.isColor}
          onBlur={props.onBlur}
        />
      </InputMobile>
      <InputDesktop>
        <Input
          inputType={props.inputType}
          width={props.widthDesktop}
          type='type'
          isLabel
          labelText={props.labelText}
          value={props.value}
          onChange={props.onChange}
          isColor={props.isColor}
          onBlur={props.onBlur}
        />
      </InputDesktop>
    </>
  );
};

export default MediaInputs;
